<template>
    <div>
        <div class="d-flex align-items-center flex-column pt-5 " v-if="!buttonClicked && (reminders.length<=0 || (!dealId &&  !activityId))">
            <img src="../assets/no-file-icon.png" alt="">
            <span class="pt-3 noReminder">Hatırlatma Yok</span>                
            <div class="row-6">    
                <button class="btn btn-primary" style="width:166px" @click="addNewReminder()"><i class="fa fa-plus"></i> {{$ml.get('ADD_REMINDER')}}</button>
            </div>
        </div>        
        <div class="container" v-else >
            <div class="row">
            <div class="div col-2"></div>
            <div class="col-8">
            <div class="row">
                <div class="col-12 pr-1 pb-2 pt-2">
                    <p align="center" >Hatırlatma eklemek için tarih ve saati seçiniz. Yeni bir hatırlatma daha eklemek için "Yeni Ekle" butonuna tıklayabilirsiniz.</p>
                    <button class="btn btn-primary" @click="addReminder()"><i class="fa fa-plus"></i> {{$ml.get('ADD_NEW')}}</button>
                </div>
            </div>
            <div class="scrollable-content pt-2 pl-2 pr-1" >
                <div class="row pb-1" v-for="(reminder,index) in reminders" v-bind:key="index">
                    <div class="row pb-2 pt-2" style="background-color: #fafafa; border:1px; margin-left:6px; border-radius:4px">
                    <div class="col-12 p-0">
                        <div class="row">
                            <div class="col-6 pl-2 pr-0">
                          <!-- <label class="new-label">{{$ml.get('DATE')}}</label> -->
                          
                            <vue-ctk-date-time-picker :locale="localeLang" :disabled="(reminder._id) ? true : false" :button-now-translation="$ml.get('TODAY')" id="estimated-closed-date"  :label="$ml.get('SELECT_DATE')" class="new-ctk" v-model="reminder.day" @input="setDate(index)" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="false" :onlyDate="true" :auto-close="true"></vue-ctk-date-time-picker>
                        </div>
                        <div class="col-4 pl-2 pr-0">
                            <!-- <label class="new-label">{{$ml.get('TIME')}}</label> -->
                            <vue-ctk-date-time-picker :locale="localeLang" :disabled="(reminder._id) ? true : false" :button-now-translation="$ml.get('TODAY')" id="activityPeriod" :label="$ml.get('TIME')" v-model="reminder.time" @input="setDate(index)" class="new-ctk"  format="HH:mm" formatted="HH:mm" :noLabel="true" :range="false" :onlyTime="true"></vue-ctk-date-time-picker>
                        </div>
                        <div class="col-2 pl-2 pr-2" >
                            <button v-if="reminder._id!==undefined&&(dealId || activityId)" class="btn btn-danger w-100 h-100 d-flex align-items-center justify-content-center p-0" @click="removeViaUpsertReminder(index)"><i class="fa fa-trash-o"></i></button>
                            <button v-else class="btn btn-danger w-100 h-100 d-flex align-items-center justify-content-center p-0" @click="removeReminder(index)"><i class="fa fa-trash-o"></i></button>
                        </div>
                    </div>
                </div>
                
                </div>
            </div>
        </div>
        <div class="row py-3" v-if="reminders.length>0 && (dealId || activityId)">
            <div class="col-12 text-center">
                <button class="btn btn-primary" @click="upsertRemindersF">{{$ml.get('SAVE')}}</button>
            </div>
        </div>
        </div>
        <div class="col-2"></div>
        </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import {mapActions, mapGetters} from 'vuex'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
Vue.component('vue-ctk-date-time-picker', VueCtkDateTimePicker)
export default {
    name:"reminderPanel",
    props:['reminders','dealId','activityId'],
    data() {
        return {
            buttonClicked: false,
        }
    },
    computed: {
        ...mapGetters(['localeLang'])
    },
    methods: {
        ...mapActions(['upsertReminder']),
        addNewReminder(){
            this.buttonClicked = true;
        },
        addReminder(){
            var newReminder = {
                day:'',
                time:'12:00',
                date:{$date:''},
                isActive:true,
                isQueued:false
            }
            var newReminders = this.reminders
            newReminders.push(newReminder)
            this.$emit('updateRemindersData',newReminders)
        },
        removeReminder(i){
            var newReminders = this.reminders
            newReminders.splice(i,1)
            this.$emit('updateRemindersData',newReminders)
        },
        removeViaUpsertReminder(i){
            var newReminders = this.reminders
            newReminders[i]['isActive']=false
            this.$emit('updateRemindersData',newReminders)
            this.upsertRemindersF()
        },
        setDate(i){
            var newReminders = this.reminders
            var day = new Date(newReminders[i].day)
            var time = newReminders[i].time
            console.log("day1")
            console.log(day)
            if(time==null || time=='' || time==undefined || newReminders[i].day==null || newReminders[i].day=='' || newReminders[i].day==undefined){
                newReminders[i].time = "12:00"
                time = "12:00"
                newReminders[i].day = ""
                day = ""
                newReminders[i].date.$date = ""
            }else{
                day.setHours(time.split(':')[0],time.split(':')[1])
                console.log("day2")
                console.log(day)
                newReminders[i].date.$date = day
            }
            console.log("newReminders")
            console.log(newReminders)
            this.$emit('updateRemindersData',newReminders)
        },
        formatUpsertList(originalList){
            
            const keys = ['date','isActive','isQueued','dealId','activityId','_id']
            const result = array => array.map( o => keys.reduce((acc,curr)=>{
                
                if(curr=='_id'){
                    acc.reminderId = {}
                    acc.reminderId = o[curr]
                }else{
                    acc[curr] = o[curr]
                }
                
                
                if(this.dealId){
                    acc.dealId = {}
                    acc.dealId.$oid = this.dealId
                }else if(this.activityId){
                    acc.activityId = {}
                    acc.activityId.$oid = this.activityId
                }
                
                return acc
            },{}))
            return result(originalList)
        },
        upsertRemindersF(){
            var remindersMutation = this.reminders.filter(r => { return r.date.$date!==''})
            if(remindersMutation.length>0){
                var form = {}
                form.objs = this.formatUpsertList(remindersMutation)
                this.upsertReminder(form).then((res)=>{return res}).then((res)=>{
                    console.log("upsertReminder res")
                    console.log(res)
                    if(res.status.code=='0'){
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('SUCCESSFUL'),
                            text: res.status.desc 
                        })
                        this.$emit('successUpsert')
                    }else{
                        this.$notify({ 
                            group: 'foo',
                            type: 'warning', 
                            title: this.$ml.get('WARNING'),
                            text: res.status.desc 
                        })
                    }
                })
            }
        }
    }
}
</script>
<style scoped>
    .scrollable-content {
        box-sizing: border-box;
        height: 292px;
        overflow-y: scroll;
        border-bottom-left-radius: 8px;
    }
    /* Hide scrollbar for Chrome, Safari and Opera */
    ::-webkit-scrollbar {
        display: none;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    .scrollable-content {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
    }
    @media (max-width: 576px) {
      .new-ctk{
          width: 85%;
          margin: 0;
      } 
      .btn-danger{
          height: 50%;
          margin-right: 15px;
          } 
      .scrollable-content {
            box-sizing: border-box;
            height: 248px;
            overflow-y: scroll;
            border-bottom-left-radius: 8px;
      }
    }
    
    .container .row{
        margin: auto;
        width: 100%;        
    }
    .btn-primary{
        width: 100%;
        font-size:15px; 
    }
    .noReminder{
        font-size: 16px;
        font-weight: 500;
        line-height: 21px;
        padding-top: 11px;
        padding-bottom: 20px;
    }
    
</style>
